<template>
    <v-container class="primary" fluid fill-height>
        <v-layout flex align-center justify-center>
            <v-flex xs12 sm4 elevation-6>
                <v-card>
                    <v-toolbar dark>
                        <v-toolbar-title>Výběr aplikace</v-toolbar-title>
                        <div class="flex-grow-1"></div>
                    </v-toolbar>
                    <v-card-text class="px-0 pt-3">
                        <template v-if="redirectData.apps && redirectData.apps.length > 0">
                            <v-list>
                                <v-list-item
                                    v-for="app in redirectData.apps.filter(a => a.url)"
                                    :key="app.id"
                                    :href="app.url || null"
                                    :target="app.url ? '_blank' : null"
                                    :disabled="!app.url"
                                >
                                    <v-list-item-content>
                                        <v-list-item-title class="font-weight-bold">{{ app.label || app.name }}</v-list-item-title>
                                        <v-list-item-subtitle class="body-2 text-underline">{{ app.url }}</v-list-item-subtitle>
                                        <v-list-item-subtitle v-if="app.description">{{ app.description }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                    <v-list-item-action v-if="app.url">
                                        <v-icon color="primary" large>mdi-open-in-new</v-icon>
                                    </v-list-item-action>
                                </v-list-item>
                                <v-divider class="my-2"></v-divider>
                            </v-list>
                            <p class="px-4">Máte oprávnění pro přístup do výše uvedených aplikací.
                                Pro přímý přístup ke konkrétní aplikaci můžete příště použít přímý odkaz, který je u aplikace uveden a který si můžete uložit na svém zařízení.</p>
                        </template>
                    </v-card-text>
                    <v-card-actions class="justify-center pb-5">
                        <v-btn @click="logout" color="primary">Odhlásit se</v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
import {mapState} from 'vuex'

export default {
    name: 'access-denied',
    computed: {
        ...mapState({
            redirectData: state => state.auth.redirectData,
        }),
    },
    methods: {
        logout() {
            this.$store.dispatch('auth/clearRedirectData');
            this.$store.dispatch('auth/logout');
        },
    },
}
</script>
